/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import TitlesView from '@folio/inventory/src/components/TitlesView';
import useDataByName from '../../../../hooks/useDataByName';

function CustomTitleFieldView({ fieldValues, data, fieldLabel }) {
  const dataSource = useDataByName('identifierTypesById');
  const { name } = fieldValues;

  return (
    <TitlesView
      id="succeedingTitles"
      titleIdKey={
        name.startsWith('preceding')
          ? 'precedingInstanceId'
          : 'succeedingInstanceId'
      }
      label={fieldLabel}
      titles={data.length ? data : [{}]}
      identifierTypesById={dataSource}
    />
  );
}

CustomTitleFieldView.propTypes = {
  fieldValues: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object),
  fieldLabel: PropTypes.string,
};

export default CustomTitleFieldView;
